import i18n from '@dms/i18n';

import {VEHICLE_FORM_EVENTS} from '../../core/machine/constants/VEHICLE_FORM_EVENTS';
import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

/**
 * Numeric input component for defining the mileage interval after which a vehicle service inspection should be performed.
 * Used in service interval tracking to set the service inspection frequency based on vehicle mileage.
 * Automatically calculates the next service inspection mileage when changed.
 */
export function ServiceInspectionAfterMileageInput() {
  const {sendMachineEvent} = useVehicleFormContext();

  const handleChange = (value: number | null) => {
    sendMachineEvent({
      type: VEHICLE_FORM_EVENTS.SERVICE_INSPECTIONS_MILEAGE_INTERVAL_CHANGED,
      value,
    });
  };

  return (
    <Field
      type="number"
      name="serviceIntervals.serviceInspection.replacementAfterMileage"
      label={i18n.t('entity.vehicle.labels.replacementAfterMileage')}
      suffix={i18n.t('general.metric.km')}
      onChange={handleChange}
    />
  );
}
